import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-transfer-jumper',
  templateUrl: './transfer-jumper.component.html',
  styleUrls: [
    './transfer-jumper.component.scss',
    '../../../components/form/form.component.scss'
  ]
})
export class TransferJumperComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  baseCode;
  baseId;
  jumpers;
  originalJumpers;
  selectedJumper = {
    name: '',
    id: ''
  };
  bases;
  selectedBase = {
    value: '',
    baseId: ''
  };
  buttonText = 'Transfer Jumper';

  constructor(private toast: ToastService) {}

  ngOnInit(): void {
    this.getJumpers();

    axios
      .get(environment.API_URL + '/base/dropdown/main', {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.bases = response.data;
        this.bases.forEach((base) => {
          base.displayValue = base.text + ' (' + base.baseCode + ')';
        });
      })
      .catch((error) => {
        console.dir(error);
      });

    this.baseCode = this.userInfo.basecode;
    this.baseId = this.userInfo.baseId;
    this.buttonText = `Transfer Jumper to ${this.userInfo.baseName} (${this.userInfo.basecode})`;
  }

  getJumpers = async () => {
    this.loading = true;

    axios
      .get(environment.API_URL + '/jumpers', {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.jumpers = response.data.value;
        this.jumpers.forEach((jumper) => {
          jumper.name =
            jumper.lastName +
            ', ' +
            jumper.firstName +
            ' | ' +
            jumper.base.code;
          jumper.base = jumper.base.code;
        });
        this.jumpers = this.sort(this.jumpers, 'name');
        this.jumpers = this.sort(this.jumpers, 'base');
        this.originalJumpers = this.jumpers;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.dir(error);
      });
  };

  selectJumper = (jumper) => {
    this.selectedJumper = jumper;
    this.bases.forEach((base) => {
      if (jumper.baseId === base.baseId) {
        this.selectBase(base);
      }
    });
  };

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  selectBase = (base) => {
    this.selectedBase = base;

    this.jumpers = this.originalJumpers;

    // filter jumpers by base
    let filteredJumpers = [];
    this.jumpers.forEach((jumper) => {
      if (jumper.baseId === this.selectedBase.baseId) {
        filteredJumpers.push(jumper);
      }
    });

    // dedupe jumpers
    let uniqueJumpers = [...new Set(filteredJumpers)];
    this.jumpers = uniqueJumpers;
  };

  transferJumper = (event) => {
    this.loading = true;
    axios
      .get(
        environment.API_URL +
          '/jumpers/transfer/?baseCode=' +
          this.baseCode +
          '&baseId=' +
          this.baseId +
          '&jumperId=' +
          this.selectedJumper.id,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show(response.data, 'success');
        this.selectedJumper = {
          name: '',
          id: ''
        };
        this.selectedBase = {
          value: '',
          baseId: ''
        };
        this.getJumpers();
      })
      .catch((error) => {
        this.toast.show('Unable to Transfer Jumper', 'error');
        this.loading = false;
        console.dir(error);
      });
  };
}
